import { ChangeDetectionStrategy, Component } from '@angular/core';

import { DsFormlyFieldType } from '@app/forms/formly/types/ds-formly-field';

@Component({
  selector: 'cc-number-field',
  templateUrl: './cc-number-field.component.html',
  styleUrls: ['./cc-number-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcNumberFieldComponent extends DsFormlyFieldType {}
